import React from "react";
const base_url = "https://m.eazistey.co.ke/API_WEB_HOOKS/"; //uses vanilla php procedural

// const node_api = "http://localhost:8001/users/";
// const php_api = "http://localhost/eazisteyapi/api/"
// export const node_base_url = "http://localhost:8000/";

const php_api = "https://m.eazistey.co.ke/API_WEB_HOOKS/api/" //uses vanilla php oop
const node_api = "https://nodeapi.eazistey.co.ke/users/"; //uses node api
export const node_base_url = "https://nodeapi.eazistey.co.ke/"; //node base url for images 


//Blogs
//post blog
export const Postblogurl = node_api + "blogs/postblog";
//fetch all blogs
export const Fetchblogsurl = node_api + "blogs/fetchallblogs";
//fetch single blog
export const Fetchsingleblogurl = node_api + "blogs/fetchsingleblog";
//fetch individual user blogs
export const Fetchindividualblogsurl = node_api + "blogs/fetchindividualuserblogs";
//update blog clicks
export const Updateblogclicksurl = node_api + "blogs/updateclicks";
//susbribe to a blog
export const Subscribeblogurl = node_api + "blogs/subscribeblog";
//follow blog author
export const Followblogurl = node_api + "blogs/followblog";
//update blog
export const Updateblogurl = node_api + "blogs/updateblog";
//delete blog
export const Deleteblogurl = node_api + "blogs/deleteblog";





//transactions
//fetch transactions url
export const Fetchtransactionsurl = base_url + "Students/fetch_payments_api.php";
//fund my wallet
export const Fundwalleturl = php_api + "clients/fundwallet_api.php";
//fstch wallet balance
export const Fetchwalleturl = node_api + "clients/fetchwallet";
//add standing order
export const Addstandingorderurl = node_api + "clients/addstandingorder";




//Services
//fetch services
export const Fetchservicesurl = base_url + "Services/fetch_catalogue_items.php";
//fetch single service
export const Fetchsingleserviceurl = base_url + "Services/fetch_singleservice_api.php";
//fetch Businesses
export const Fetchbusinessesurl = base_url + "Services/fetch_service_api.php";
//fetch individual Business person 
export const FetchSinglebizurl = base_url + "Services/fetch_serviceownerdetails_api.php";
//fetch my businesses
export const Fetchmybusinessesurl = base_url + "Services/fetch_singleservice_api.php"
//fetch my single biz
export const Fetchmysinglebizurl = base_url + "Services/fetch_singleservice_api.php"
//update my biz
export const Updatemybizurl = base_url + "Services/update_service_api.php"




//upload property main image url
export const Uploadprofileurl = base_url + "upload_profilepic_api.php?5$jj8maliplus=hh&id=";

//upload property slot image url
export const Uploadslotimageurl = base_url + "upload_slotimage_api.php?5$jj8maliplus=hh";

//check app udate url
export const Checkupdateurl = node_api + "App/check_appupdate_api.php";

//Fetch houses url
export const Fetchhousesurl = node_api + "houses/fetchhostels";//done
//search houses
export const Searchhousesurl = node_api + "houses/searchhouses"

//add property
export const Addpropertyurl = node_api + "landlords/addproperty";



//save client plan
export const Saveclientplanurl = node_api + "clients/saveplan";
//save clients details url
export const Savedetailsurl = php_api + "clients/change_details_api.php";//done
//change password url 
export const Changepassurl = php_api + "clients/change_password_api.php";//done
//send email from subscription
export const subscribeurl = php_api + "clients/subscribenewsletter.php";
//send contact us message
export const Contactusmessage = php_api + "clients/contact_us.php";//done
//fetch shared profiles
export const Fetchsharedprofilesurl = php_api + "clients/fetch_shared_profiles.php";//done
//change sharing status 
export const Changesharingstatusurl = php_api + "clients/change_sharing_profile.php";//done
//change dp url
export const Changedpurl = base_url + "update_profilepic_api.php?5$jj8maliplus=hh&id=";//done
//Login url
export const Loginurl = php_api + "common/login_api.php";//done
//google login
export const Googleloginurl = php_api + "common/google_login_api.php"
//Reset password url
export const Resetpassurl = php_api + "common/resetpass.php";//done
//Register url 
export const Registerurl = php_api + "common/registerclient.php";//done
//validate register code
export const Validateregistercodeurl = php_api + "common/validate_registration_code.php"
//default app images url 
export const Defaultimageurl = node_api + "Images/logo.png";
//fetch single house url
export const Singlehouseurl = node_api + "houses/fetchsinglehostel";//done
//Landlord make payment
export const Makepaymenturl = node_api + "landlords/add_house_api.php";
//post house images during house registration
export const Posthouseimagesurl = node_api + "landlords/posthouseimages"


//Fetch my properties url 
export const Fetchmypropertiesurl = node_api + "landlords/fetchlandlordproperties";//done
//save property details url
export const Savehousedetailsurl = node_api + "landlords/updatehouse";//done
//Read all messages url
export const Readmessageurl = php_api + "messages/read_message_api.php";//done
//Fetch messages url 
export const Fetchmessagesurl = php_api + "messages/fetch_messages_api.php";//done
//Post message url 
export const Postmessagesurl = php_api + "messages/post_message_api.php";//done
//update deleted messages url
export const updatedeletedmessagesurl = node_api + "messages/post_deletedmessage_api.php";//done
//Fetch notifications url 
export const Fetchnotificationsurl = php_api + "notifications/fetch_notifications_api.php";//done
//unread messages url 
export const Unreadmessagesurl = php_api + "messages/get_unreadcounter_api.php";//done 
//update clicks url
export const Updateclicks = node_api + "houses/updateclicks";//done
//update likes url
export const Updatelikes = node_api + "houses/likehouse";//done
//send review
export const Updatereviewurl = node_api + "houses/updatereview"



//search requestss
//post search requests
export const Postsearchrequest = php_api + "clients/post_search_request.php"
//fetch individual search request
export const Fetchsearchrequesturl = php_api + "clients/fetch_searchrequest_api.php"
//recover tracking number
export const Recovertrackingnumberurl = php_api + "clients/recover_tracking_number.php"


//site visits
export const Postsitevisiturl = node_api + "clients/postsitevisit"




